import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnMode } from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import { FinanceService } from '../../../../shared/services/admServices/finance.service';


@Component({
  selector: 'adm-invoice-component',
  templateUrl: './invoice-component.html',
  styleUrls: ['./invoice-component.scss'],
})
export class fininvoiceComponent implements OnInit {
  invoiceData: any;

  ColumnMode = ColumnMode;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private toastrService: ToastrService,
              private financeService: FinanceService) {

  }

  ngOnInit(): void {
    this.getInvoice(this.route.snapshot.params?.['id']);
  }

  getInvoice(id: string): void {
    this.financeService.getInvoice(id)
    .subscribe(
     data => {
      this.invoiceData = data.data;
     },
     error => {
       console.log(error);
     });
  }

  onPay(): void {
    this.financeService.payInvoice(this.invoiceData.payoutId)
    .subscribe(
     data => {
      this.toastrService.success('Paid correctly.', 'Success !');
      this.router.navigate(['/adm/payments']);
       },
     error => {
       console.log(error);
       this.toastrService.error('Ups...is not paid', 'Error !');
     });
  }

  onRevert(): void {
    this.financeService.revertInvoice(this.invoiceData.payoutId)
    .subscribe(
     data => {
      this.toastrService.success('Reverted correctly.', 'Success !');
      this.router.navigate(['/adm/payments']);
       },
     error => {
       console.log(error);
       this.toastrService.error('Ups...is not reverted', 'Error !');
     });
  }

  onCancel(): void {
    this.router.navigate(['/adm/payments']);
  }
}
